import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Product } from '@/types';

interface WishlistState {
  items: Product[];
}

const initialState: WishlistState = {
  items: [],
};

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<Product[]>) => {
      state.items = action.payload;
    },
    addItem: (state, action: PayloadAction<Product>) => {
      const exists = state.items.some((item) => item.id === action.payload.id || item.uuid === action.payload.uuid);
      if (!exists) state.items.push(action.payload);
    },
    toggleItem: (state, action: PayloadAction<Product>) => {
      const index = state.items.findIndex((item) => item.id === action.payload.id);
      if (index !== -1) {
        state.items.splice(index, 1);
      } else {
        state.items.push(action.payload);
      }
    },
    removeItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload && item.uuid !== action.payload);
    },
    clearWishlist: (state) => {
      state.items = [];
    },
  },
});

export const wishlistActions = wishlistSlice.actions;
